module.exports = require("@noble/hashes/blake2b");